import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { getFlashcardsCollectionPath } from "./firestorePaths";

const getFlashcardsCollectionRef = (db, userId) =>
  collection(db, getFlashcardsCollectionPath(userId));

export const createFlashcardRecord = async ({ db, userId, payload }) => {
  if (!db || !userId) {
    throw new Error("Missing db or userId for flashcard creation.");
  }
  const collectionRef = getFlashcardsCollectionRef(db, userId);
  const docRef = await addDoc(collectionRef, payload);
  return { id: docRef.id };
};

export const fetchDueFlashcards = async ({
  db,
  userId,
  nowMs = Date.now(),
  limitCount = 5,
} = {}) => {
  if (!db || !userId) {
    throw new Error("Missing db or userId for flashcard fetch.");
  }
  const collectionRef = getFlashcardsCollectionRef(db, userId);
  const dueQuery = query(
    collectionRef,
    where("dueAt", "<=", nowMs),
    orderBy("dueAt"),
    limit(limitCount)
  );
  const snapshot = await getDocs(dueQuery);
  return snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));
};

export const updateFlashcardRecord = async ({ db, userId, cardId, updates }) => {
  if (!db || !userId || !cardId) {
    throw new Error("Missing db, userId, or cardId for flashcard update.");
  }
  const collectionRef = getFlashcardsCollectionRef(db, userId);
  const docRef = doc(collectionRef, cardId);
  await updateDoc(docRef, updates);
};

export const fetchFlashcards = async ({
  db,
  userId,
  limitCount = 200,
  orderField = "updatedAt",
  orderDirection = "desc",
} = {}) => {
  if (!db || !userId) {
    throw new Error("Missing db or userId for flashcard fetch.");
  }
  const collectionRef = getFlashcardsCollectionRef(db, userId);
  const q = query(
    collectionRef,
    orderBy(orderField, orderDirection),
    limit(limitCount)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));
};

export const deleteFlashcardRecord = async ({ db, userId, cardId }) => {
  if (!db || !userId || !cardId) {
    throw new Error("Missing db, userId, or cardId for flashcard deletion.");
  }
  const collectionRef = getFlashcardsCollectionRef(db, userId);
  const docRef = doc(collectionRef, cardId);
  await deleteDoc(docRef);
};

const flashcardStore = {
  createFlashcardRecord,
  fetchDueFlashcards,
  fetchFlashcards,
  updateFlashcardRecord,
  deleteFlashcardRecord,
};

export default flashcardStore;
